import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=5db3dd1b&scoped=true&"
import script from "./NavigationMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=5db3dd1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db3dd1b",
  null
  
)

export default component.exports